import React, { FormEvent, useCallback, useEffect, useState } from "react";

import Button from "../../../shared/components/design-system/Button";
import PasswordInput from "../../../shared/components/design-system/TextInput/PasswordInput";
import { useTranslate } from "../../translation/frontend";

export default function LoginCode({ sendLoginCode }: { sendLoginCode: (reportCode: string) => Promise<boolean> }) {
  const translate = useTranslate();
  const [loading, setLoading] = useState(false);
  const [errored, setErrored] = useState(false);
  const [code, setCode] = useState("");

  const handleFormSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      setErrored(false);
      setLoading(true);
      try {
        setErrored(!(await sendLoginCode(code)));
      } finally {
        setLoading(false);
      }
    },
    [sendLoginCode, code],
  );

  useEffect(() => setErrored(false), [code]);

  return (
    <form onSubmit={handleFormSubmit}>
      <div className="messaging__code-container">
        <PasswordInput
          required
          label={translate("messagingCode")}
          labelVariant="hidden"
          value={code}
          onChange={setCode}
          serverValidity={errored ? translate("messagingCodeInvalid") : undefined}
          className="messaging__input-container"
        />
        <Button submit label={translate("messagingCodeSubmit")} loading={loading} variant="primary" />
      </div>
    </form>
  );
}
